export const appTengeIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path d="M0 0H24V24H0z"/><path fill="currentColor" d="M6 11.314V8.503h12v2.811h-4.394V20h-3.212v-8.686H6zm0-4.503V4h12v2.811H6z"/></g></svg>`,
    name: 'tenge' as const
};